module.exports = __webpack_public_path__ + "img/arrow-left.022355d6.svg";